import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { normalizeInstagramUrl } from '../lib/social';
import { mergeFeaturedFarmers } from '../data/farmers';

export default function TimeTreePage() {
  const instagramUrl = normalizeInstagramUrl(import.meta.env.VITE_INSTAGRAM_PROFILE_URL);
  const [farmers, setFarmers] = useState([]);
  const introMovieUrl = 'https://www.youtube.com/watch?v=oM0OAlGwJr8';

  useEffect(() => {
    setFarmers(mergeFeaturedFarmers([]).slice(0, 24));
  }, []);

  const fulltimeFarmers = farmers.filter((farmer) => (farmer.farmerType || 'fulltime') === 'fulltime');
  const lifestyleFarmers = farmers.filter((farmer) => (farmer.farmerType || 'fulltime') === 'parttime');
  const introEmbedUrl = introMovieUrl.replace('watch?v=', 'embed/');

  return (
    <>
      <Helmet><title>Drs.Farm | TimeTree</title></Helmet>
      <h1>Drs.Farm TimeTree</h1>
      <p className="page-lead">紹介動画、リンク集、参加農家リンクをまとめて確認できます。</p>

      <section className="panel">
        <h2>公式サイトはこちら！</h2>
        <div className="row-actions">
          <Link className="btn btn-primary" to="/">トップページへ</Link>
        </div>
      </section>

      <section className="panel">
        <h2>紹介動画</h2>
        <div className="youtube-embed-wrap">
          <iframe
            className="youtube-embed"
            src={introEmbedUrl}
            title="Drs.Farm 紹介動画"
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        </div>
      </section>

      <section className="panel">
        <h2>リンク集</h2>
        <div className="row-actions">
          <a className="btn btn-primary" href={instagramUrl} target="_blank" rel="noreferrer">Instagram</a>
          <a className="btn btn-secondary" href="mailto:drs.farm.info@gmail.com">メールで問い合わせ</a>
          <Link className="btn btn-secondary" to="/posts">記事一覧</Link>
          <Link className="btn btn-secondary" to="/farmers">参加農家一覧</Link>
        </div>
      </section>

      <section className="panel">
        <h2>参加農家リンク</h2>
        {farmers.length === 0 ? (
          <p>農家リンクを読み込み中...</p>
        ) : (
          <>
            <h3>専業農家</h3>
            <div className="cards">
              {fulltimeFarmers.map((farmer) => (
                <article className="card" key={farmer.id}>
                  <img src={farmer.heroImageUrl} alt={farmer.name} loading="lazy" />
                  <div className="card-body">
                    <h3>{farmer.name}</h3>
                    <p>{farmer.prefecture} {farmer.city}</p>
                    <p className="meta-text">{(farmer.crops || []).join(' / ')}</p>
                    <Link className="text-btn" to={`/farmers/${farmer.slug}`}>農家ページへ</Link>
                  </div>
                </article>
              ))}
            </div>

            <h3 style={{ marginTop: '2.5rem' }}>ライフスタイル農家</h3>
            <div className="cards">
              {lifestyleFarmers.map((farmer) => (
                <article className="card" key={farmer.id}>
                  <img src={farmer.heroImageUrl} alt={farmer.name} loading="lazy" />
                  <div className="card-body">
                    <h3>{farmer.name}</h3>
                    <p>{farmer.prefecture} {farmer.city}</p>
                    <p className="meta-text">{(farmer.crops || []).join(' / ')}</p>
                    <Link className="text-btn" to={`/farmers/${farmer.slug}`}>農家ページへ</Link>
                  </div>
                </article>
              ))}
            </div>
          </>
        )}
      </section>
    </>
  );
}
